import angular from 'angular';
import Chart from 'chart.js/auto';
import '../../shared.module';
import template from './chart.component.html';
import './chart.component.scss';

class ChartController {
  constructor($element) {
    this.$element = $element;
  }

  $postLink() {
    const canvas = this.$element[0].querySelector('canvas');
    this.chart = new Chart(canvas, {
      type: this.type || 'line',
      data: this.data,
      options: this.options || { responsive: true, maintainAspectRatio: false }
    });
  }

  $onChanges(changes) {
    if (!this.chart || !changes.data || changes.data.isFirstChange()) return;
    this.chart.data = this.data;
    this.chart.update();
  }

  $onDestroy() {
    if (this.chart) this.chart.destroy();
  }
}

ChartController.$inject = ['$element'];

angular.module('app.shared').component('cpChart', {
  bindings: {
    type: '@',
    data: '<',
    options: '<'
  },
  controller: ChartController,
  controllerAs: 'vm',
  template
});
